var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-alert',{attrs:{"active":_vm.isActive,"color":_vm.type,"icon":_vm.icon,"closable":_vm.closable,"close-icon":"close"},on:{"update:active":function($event){_vm.isActive=$event}}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }